import PageHeader from "../../../../shared/components/blocks/PageHeader";

export default function CreateFormHeader() {
  return (
    <PageHeader
      title="Create Calendar"
      breadcrumbs={[
        { label: "Calendars", to: "/calendars" },
        { label: "Create", to: "#" },
      ]}
    />
  );
}
